import './loader.js'
import 'ckeditor'

import './plugin/videoembed/dialogs/videoembedDialog.js'
import './plugin/videoembed/plugin.js'